/* eslint-disable no-param-reassign, @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { config } from '@/utils';

export type TVehicle = {
  id: string;
  name: string;
  modifications: {
    id: string;
    name: string;
    modelYears: string[];
    grades: {
      id: string;
      name: string;
      colors: {
        colorName: string;
        topHexCode: string;
        bodyHexCode: string;
      }[];
      options: {
        group: string;
        items: string[];
      }[];
      versions: {
        id: string;
        name: string;
        price: number;
        suzukiFinanceDiscount?: number; // Выгода по программе Suzuki Finance для suzuki
        anotherBrandSuzukiFinanceDiscount?: number;
        tradeInDiscount?: number; // Выгода по программе трейд-ин, руб для suzuki
        anotherBrandTradeInDiscount?: number;
        medicalDiscount?: number;
        driveType: string;
        engine: {
          volumetext: string;
        };
        transmission: {
          transmissiontype: string;
        };
      }[];
    }[];
    disclaimers: {
      [key: string]: string | undefined;
      credit?: string;
      medical?: string;
      price?: string;
      tradein?: string;
    };
  }[];
};

type ApiResponce = {
  vehicles: TVehicle[];
};

type VehiclesSliceState = {
  vehicles?: TVehicle[];
  loading: boolean;
  error?: boolean;
};

const initialState: VehiclesSliceState = {
  loading: false,
};

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    request: state => {
      state.loading = true;
    },
    success: (state, action: PayloadAction<TVehicle[]>) => {
      state.vehicles = action.payload;
      state.loading = false;
    },
    error: state => {
      state.error = true;
      state.loading = false;
    },
  },
});

const getVehicles = () => (dispatch: Dispatch) => {
  dispatch(vehiclesSlice.actions.request());

  return fetch(config.get('vehiclesCatalogApi'))
    .then(res => res.json())
    .then((res: ApiResponce) => {
      dispatch(vehiclesSlice.actions.success(res.vehicles));
    })
    .catch(e => {
      dispatch(vehiclesSlice.actions.error());
    });
};

const actions = {
  ...vehiclesSlice.actions,
  getVehicles,
};

export { vehiclesSlice as default, actions };
